import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { pctSymbol } from '../../../../utils/formatters';

const AdditionalPracticeInformationSection = ({ user, onEdit }) => {
  const intl = useIntl();

  const formatBoolean = (value) => {
    if (value === true) return intl.formatMessage({ id: 'succession.profile_edit.common.true' });
    if (value === false) return intl.formatMessage({ id: 'succession.profile_edit.common.false' });
    return intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' });
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' });
    return value.toString();
  };

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-succession-text-primary">{intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.title' })}</h3>
        <button
          onClick={onEdit}
          className="inline-flex items-center px-3 py-1.5 border border-succession-border rounded-lg text-sm text-succession-text-primary hover:bg-succession-bg-primary transition-colors"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {intl.formatMessage({ id: 'succession.profile_edit.common.edit' })}
        </button>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.defined_investment_style' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatBoolean(user.defined_investment_style)}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.defined_service_model' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatBoolean(user.defined_service_model)}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.part_of_team' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatBoolean(user.part_of_team)}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.team_size' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatNumber(user.team_size)} {user.team_size && user.team_size > 1 ? intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.members' }) : intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.member' })}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.number_of_employees' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatNumber(user.number_of_employees)}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.service_niche_market' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatBoolean(user.niche_market)}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.good_standing_with_regulators' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {formatBoolean(user.good_standing_with_regulator)}
          </p>
        </div>

        <div>
          <p className="text-sm font-medium text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_edit.sections.additional_practice_information.persistency_rate' })}
          </p>
          <p className="text-sm text-succession-text-muted">
            {user.persistency ? `${user.persistency}${pctSymbol()}` : intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' })}
          </p>
        </div>
      </div>
    </div>
  );
};

AdditionalPracticeInformationSection.propTypes = {
  user: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default AdditionalPracticeInformationSection;
